import React from 'react';
import './grah-karj.css';

const GrahKarj = () => {
  return (
    <div className="grah-karj-container">
      <div className="banner">
      <img src="/images/slider1.jpg" alt="Banner" className="banner" />
    </div>
    
      <h1>गृह कर्ज</h1>
      <p>
        या व्यवहारी जगात घर घेण्यासाठी मोठी आर्थिक गुंतवणूक आवश्यक असते. अनेकदा घर खरेदीसाठी आयुष्यभराची कमाई पणाला लागते 
        आणि काहींसाठी हे स्वप्नच आवाक्याबाहेरचे वाटते. पण आता नाही! <strong>श्री वरद विनायक पतसंस्था </strong> तुमचं हे स्वप्न साकार 
        करण्यासाठी घेऊन येत आहे <strong>गृहकर्ज योजना</strong> – त्वरित आणि कमी व्याजदरात! कमीत कमी कागदपत्रांमध्ये, 
        जलद मंजुरीसह तुम्हाला सहज गृहकर्ज उपलब्ध करून देत आहे. त्यामुळे तुमचं घर घेण्याचं स्वप्न आता आणखी सोपं आणि सुलभ!
      </p>

      <h1>आवश्यक कागदपत्रे:</h1>
      <ul>
        <li>मालमत्तेचा सर्च रिपोर्ट</li>
        <li>मालमत्तेचा मूल्यांकन रिपोर्ट</li>
        <li>500 रुपये चे दोन स्टॅम्प पेपर</li>
        <li>मालमत्तेचे गहान खत (मोर्गेज)</li>
        <li>इतर संस्थेची (NOC)</li>
        <li>पोस्टाचे 4 तिकीट</li>
        <li>15 चेक</li>
        <li>2 फोटो</li>
        <li>दोन जामीनदार व त्यांचे आधार कार्ड (झेरॉक्स)</li>
      </ul>
    </div>
  );
};

export default GrahKarj;
